<p-button
    class="contact-us-button"
    [icon]="'pi pi-question-circle'"
    [rounded]="true"
    [severity]="'warn'"
    [size]="'large'"
    [pTooltip]="'Support in the Telegram'"
    (onClick)="onClick()" />
